/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["meia-noite", "meio-dia", "da manhã", "da tarde", "da noite", "da madrugada"], u, u], [["meia-noite", "meio-dia", "manhã", "tarde", "noite", "madrugada"], u, u], ["00:00", "12:00", ["06:00", "12:00"], ["12:00", "19:00"], ["19:00", "24:00"], ["00:00", "06:00"]]];
